import * as solidIcons from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DescriptedLabel } from 'iebt-zing-storybook'
import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { LabelInputFile } from 'sharedKernel/styledComponents/fileComponents/styles'
import { v4 as uuidv4 } from 'uuid'
import { showToast } from '../../../../../../../../components/toast'
import { IMultiFile } from '../../constants'
import { LabelInputFileDescription } from '../../style'
import { ACCEPTED_SUPPORT_FILES } from './constants'

export function BuildMultiFile(item: IMultiFile, key: number | string): any {
  const [state, setState] = useState<IMultiFile>(item)
  const isSupportFile = item.id === 'supportFiles'
  const allowedTypes = [
    'application/pdf',
    'application/msword',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'application/vnd.oasis.opendocument.text',
    'application/vnd.oasis.opendocument.spreadsheet',
    'application/vnd.oasis.opendocument.presentation',
    'image/jpeg', 'image/png', 'image/png', 'image/jpg', 'image/gif', 'image/tiff', 'image/psd', 'image/eps', 'image/ai',
    'image/indd', 'image/raw', 'image/cdr', 'image/tif', 'image/bmp', 'image/cr2', 'image/nef', 'image/orf', 'image/sr2', 'video/wma',
    'video/mp3', 'video/mp4', 'video/wav', 'video/ogm', 'video/wmv', 'video/mpg', 'video/mpeg', 'video/webm', 'video/ogv', 'video/mov', 'video/asx',
    'video/avi', 'video/m4v'
  ]

  const getFileIcon = (fileName: string | null) => {
    if (!fileName) return solidIcons.faFile;

    const ext = fileName.split('.').pop()?.toLowerCase();
    if (!ext) return solidIcons.faFile;

    const imageExts = ["jpg", "jpeg", "png", "gif", "bmp", "webp", "tiff"];
    if (imageExts.includes(ext)) {
      return solidIcons.faFileImage;
    }

    const iconName = `faFile${ext.charAt(0).toUpperCase()}${ext.slice(1)}`;
    return (solidIcons as any)[iconName] ?? solidIcons.faFile;
  };


  return (
    <div style={{ margin: '0px 0px 10px 10px' }} key={key}>
      <DescriptedLabel description={item.description} boldText={item.isRequired ?? false} htmlFor={item.id}>
        {item.label}
      </DescriptedLabel>
      <LabelInputFile id={item.id} isClickable>
        <FontAwesomeIcon className="pr-2" icon={['fas', 'cloud-arrow-up']} />
        {'Adicionar Arquivos'}
        <input
          className="form-check-input"
          type="file"
          multiple
          accept={isSupportFile ? ACCEPTED_SUPPORT_FILES : '*'}
          name={item.id}
          id={item.id}
          onChange={(event) => {
            const element = event?.target as HTMLInputElement
              ;[].slice.call(element.files).forEach((file: File) => {
                if (isSupportFile && file.size > 52428800) {
                  showToast('warning', 'Cada arquivo deve ter um tamanho máximo de 50 MB')
                  return
                }
                if (!isSupportFile && file.size > 5242880) {
                  showToast('warning', 'Cada arquivo deve ter um tamanho máximo de 5 MB')
                  return
                }

                if (!allowedTypes.includes(file.type)) {
                  showToast('warning', `Arquivo ${file.name} não é permitido.`)
                  return
                }

                if (state.archives === undefined) {
                  state.archives = []
                }

                state.archives.push({
                  id: `${String(uuidv4())}_idScreen`,
                  path: URL.createObjectURL(file),
                  isDeleted: false,
                  name: file.name,
                  size: file.size,
                  mimetype: file.type,
                  extension: null,
                  type: state.type,
                  content: null,
                  sourceFile: file
                })

                setState({ ...state })
                if (state.updateFieldState !== undefined && state.updateFieldState !== null) {
                  state.updateFieldState(state)
                }
              })
            event.target.value = ''
          }}
        />
      </LabelInputFile>
      <LabelInputFileDescription>
        {item.description}
      </LabelInputFileDescription>
      {state.archives?.map((file, index) => {
        if (file.isDeleted) {
          return
        }

        return (
          <div className="d-flex flex-row bd-highlight pb-8">
            <div className="p-2 bd-highlight col-5" key={index}>
              {/* eslint-disable-next-line multiline-ternary */}
              {file.path != null ? (
                <a href={file.path} target="_blank" className="text-decoration-none p-0 w-full btn btn-outline-primary border-0 rounded-start">
                  <LabelInputFile className="label-file">
                    <FontAwesomeIcon className="pr-2" icon={getFileIcon(file.name)} />
                    {file.name
                      ? (file.name.length > 50
                        ? file.name.slice(0, 50) + "..." + file.name.slice(-6)
                        : file.name)
                      : ""
                    }
                  </LabelInputFile>
                </a>
              ) : (
                <LabelInputFile className="w-full fs-6 fst-normal ">
                  <FontAwesomeIcon className="pr-2" icon={['fas', 'file']} />
                  {file.name?.slice(0, 40)}...{file.name?.slice(-6)}
                </LabelInputFile>
              )}
            </div>
            <div className="p-2 bd-highlight col-1">
              <Button
                className="btn-delete-file"
                onClick={() => {
                  if (!confirm('Tem certeza que deseja excluir este arquivo')) {
                    return
                  }

                  if (state.removed === undefined) {
                    state.removed = []
                  }

                  if (!file.id.includes('_idScreen')) {
                    state.removed.push(file.id)
                  }
                  // @ts-expect-error
                  state.archives[index].isDeleted = true
                  setState({ ...state })
                }}
              >
                <FontAwesomeIcon icon={['fas', 'close']} />
              </Button>
            </div>
          </div>
        )
      })}
    </div>
  )
}
